import React from "react";
import { Route } from "react-router-dom";
import { Layout } from "../pages/layout/Layout";

import ProtectedRoute from "../routes/ProtectedRoute";
import { AdminHome } from "../pages/admin/home/AdminHome";

import { ViewContest } from "../pages/admin/contests/ViewContest";
import { Participate } from "../pages/artists/contests/Participate";
import { CommentContests } from "../pages/admin/contests/CommentContest";

import { ContestsModal } from "../components/modal/Modal";
import { ContestResult } from "../pages/admin/contests/ContestResult";
import { Contests } from "../pages/contest/Contest";
import { ArtistsList } from "../pages/admin/artists/ArtistsList";
import { EventsList } from "../pages/admin/events/EventsList";
import UserProfile from "../pages/profile/UserProfile";
import ArtistProfile from "../pages/profile/ArtistProfile";
import CreateArtist from "../pages/artists/artists/CreateArtist";
import { AdminContestDetail } from "../pages/admin/contests/AdminContestDetail";
import { UserSList } from "../pages/admin/artists/UsersList";
import SubscribePlan from "../pages/admin/revenue/SubscribePlan";
import Rewards from "../pages/admin/revenue/Rewards";
import Revenue from "../pages/admin/revenue/Revenue";
import { Notifications } from "../pages/notification/Notifications";
import { UserHome } from "../pages/users/UserHome";
import AdminProfile from "../pages/profile/AdminProfile";
import CreateEvent from "../pages/admin/events/CreateEvent";
import Earning from "../pages/admin/earning/Earning";
import CreateReward from "../pages/admin/revenue/CreateReward";

export const AdminRoutes = () => (
  
  <Route element={<ProtectedRoute />}>
      <Route path="/admin" element={<Layout />}>
                <Route index element={<AdminHome />} />
                <Route path="contests/:statusCode" element={<Contests />} />
                <Route path="contest-detail/:purpose/:contestId" element={<AdminContestDetail />} />
                <Route path="view-contest" element={<ViewContest />} />
                <Route path="participate-contests" element={<Participate />} />
                <Route path="comment-contests" element={<CommentContests />} />
                <Route path="artists" element={<ArtistsList />} />
                <Route path="events" element={<EventsList />} />
                <Route path="users" element={<UserSList />} />
                <Route path="user-profile/:userId" element={<UserProfile />} />
                <Route path="artist-profile/:userId" element={<ArtistProfile />} />
                <Route path="profile/:userId" element={<AdminProfile />} />
                <Route path="contest-modal" element={<ContestsModal />} />
                <Route path="send-results" element={<ContestResult />} />
                <Route path="create-artist" element={<CreateArtist />} />
                <Route path="create-event" element={<CreateEvent />} />
                <Route path="edit-event/:id" element={<CreateEvent />} />
            
                <Route path="subscribe-plans" element={<SubscribePlan />} />
                <Route path="rewards" element={<Rewards />} />
                <Route path="create-reward" element={<CreateReward />} />
                <Route path="edit-reward/:id" element={<CreateReward />} />
                <Route path="revenue" element={<Revenue />} />
                <Route path="earnings" element={<Earning />} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="create-contest" element={<UserHome />} />
                <Route path="contest-results/:contestId" element={<ContestResult />} />
            </Route>
            </Route>
);
